import { actions } from './QuickshopWebReducer';

export function attemptResetNotificationState(data) {
  return { type: actions.ATTEMPT_RESET_NOTIFICATION_STATE, payload: { data } };
}

export function attemptUpdateQuickshop(data) {
  return { type: actions.ATTEMPT_UPDATE_QUICKSHOP, payload: { data } };
}

export function attemptUpdateQuickshopSucceed() {
  return { type: actions.ATTEMPT_UPDATE_QUICKSHOP_SUCCEED };
}

export function attemptUpdateQuickshopFailed(data) {
  return { type: actions.ATTEMPT_UPDATE_QUICKSHOP_FAILED, payload: { data } };
}

export function attemptStartRental(data) {
  return { type: actions.ATTEMPT_START_RENTAL, payload: { data } };
}

export function attemptStartRentalSucceed(data) {
  return { type: actions.ATTEMPT_START_RENTAL_SUCCEED, payload: { data } };
}

export function attemptStartRentalFailed(data) {
  return { type: actions.ATTEMPT_START_RENTAL_FAILED, payload: { data } };
}

export function attemptEndRental(data) {
  return { type: actions.ATTEMPT_END_RENTAL, payload: { data } };
}

export function attemptEndRentalSucceed() {
  return { type: actions.ATTEMPT_END_RENTAL_SUCCEED };
}

export function attemptEndRentalFailed(data) {
  return { type: actions.ATTEMPT_END_RENTAL_FAILED, payload: { data } };
}

export function attemptLinkQuickshop(data) {
  return { type: actions.ATTEMPT_LINK_QUICKSHOP, payload: { data } };
}

export function attemptLinkQuickshopSucceed() {
  return { type: actions.ATTEMPT_LINK_QUICKSHOP_SUCCEED };
}

export function attemptLinkQuickshopFailed(data) {
  return { type: actions.ATTEMPT_LINK_QUICKSHOP_FAILED, payload: { data } };
}

export function attemptGetPOSSession(data) {
  return { type: actions.ATTEMPT_GET_POS_SESSION, payload: { data } };
}

export function attemptGetPOSSessionSucceed(data) {
  return { type: actions.ATTEMPT_GET_POS_SESSION_SUCCEED, payload: { data } };
}

export function attemptGetPOSSessionFailed(data) {
  return { type: actions.ATTEMPT_GET_POS_SESSION_FAILED, payload: { data } };
}

export function attemptStopPOSSession(data) {
  return { type: actions.ATTEMPT_STOP_POS_SESSION, payload: { data } };
}

export function attemptStopPOSSessionSucceed(data) {
  return { type: actions.ATTEMPT_STOP_POS_SESSION_SUCCEED, payload: { data } };
}

export function attemptStopPOSSessionFailed(data) {
  return { type: actions.ATTEMPT_STOP_POS_SESSION_FAILED, payload: { data } };
}

export function attemptOnlyStartPOSSession() {
  return { type: actions.ATTEMPT_ONLY_START_POS_SESSION };
}

export function attemptStartPOSSession(data) {
  return { type: actions.ATTEMPT_START_POS_SESSION, payload: { data } };
}

export function attemptStartPOSSessionSucceed(data) {
  return { type: actions.ATTEMPT_START_POS_SESSION_SUCCEED, payload: { data } };
}

export function attemptStartPOSSessionFailed(data) {
  return { type: actions.ATTEMPT_START_POS_SESSION_FAILED, payload: { data } };
}

export function attemptGetBookingCart(data) {
  return { type: actions.ATTEMPT_GET_BOOKING_CART, payload: { data } };
}

export function attemptGetBookingCartSucceed(data) {
  return { type: actions.ATTEMPT_GET_BOOKING_CART_SUCCEED, payload: { data } };
}

export function attemptGetBookingCartFailed(data) {
  return { type: actions.ATTEMPT_GET_BOOKING_CART_FAILED, payload: { data } };
}

export function attemptAddProductToCart(data) {
  return { type: actions.ATTEMPT_ADD_PRODUCT_TO_CART, payload: { data } };
}

export function attemptAddProductToCartSucceed(data) {
  return { type: actions.ATTEMPT_ADD_PRODUCT_TO_CART_SUCCEED, payload: { data } };
}

export function attemptAddProductToCartFailed(data) {
  return { type: actions.ATTEMPT_ADD_PRODUCT_TO_CART_FAILED, payload: { data } };
}

export function attemptCheckSwishPaymentStatus(data) {
  return { type: actions.ATTEMPT_CHECK_SWISH_PAYMENT_STATUS, payload: { data } };
}

export function attemptCheckSwishPaymentStatusSucceed(data) {
  return { type: actions.ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_SUCCEED, payload: { data } };
}

export function attemptCheckSwishPaymentStatusFailed(data) {
  return { type: actions.ATTEMPT_CHECK_SWISH_PAYMENT_STATUS_FAILED, payload: { data } };
}

export function attemptPayPOSSession(data) {
  return { type: actions.ATTEMPT_PAY_POS_SESSION, payload: { data } };
}

export function attemptPayPOSSessionSucceed(data) {
  return { type: actions.ATTEMPT_PAY_POS_SESSION_SUCCEED, payload: { data } };
}

export function attemptPayPOSSessionFailed(data) {
  return { type: actions.ATTEMPT_PAY_POS_SESSION_FAILED, payload: { data } };
}

export function attemptGetQuickshop(data) {
  return { type: actions.ATTEMPT_GET_QUICKSHOP, payload: { data } };
}

export function attemptGetQuickshopSucceed(data) {
  return { type: actions.ATTEMPT_GET_QUICKSHOP_SUCCEED, payload: { data } };
}

export function attemptGetQuickshopFailed(data) {
  return { type: actions.ATTEMPT_GET_QUICKSHOP_FAILED, payload: { data } };
}

export function attemptGetTopMeasurementData(data) {
  return { type: actions.ATTEMPT_GET_TOP_MEASUREMENT_DATA, payload: { data } };
}

export function attemptGetTopMeasurementDataSucceed(data) {
  return { type: actions.ATTEMPT_GET_TOP_MEASUREMENT_DATA_SUCCEED, payload: { data } };
}

export function attemptGetTopMeasurementDataFailed(data) {
  return { type: actions.ATTEMPT_GET_TOP_MEASUREMENT_DATA_FAILED, payload: { data } };
}

export function attemptGetReceiptData(data) {
  return { type: actions.ATTEMPT_GET_RECEIPT_DATA, payload: { data } };
}

export function attemptGetReceiptDataSucceed(data) {
  return { type: actions.ATTEMPT_GET_RECEIPT_DATA_SUCCEED, payload: { data } };
}

export function attemptGetReceiptDataFailed(data) {
  return { type: actions.ATTEMPT_GET_RECEIPT_DATA_FAILED, payload: { data } };
}

export function attemptGetMeasurementData(data) {
  return { type: actions.ATTEMPT_GET_MEASUREMENT_DATA, payload: { data } };
}

export function attemptGetMeasurementDataSucceed(data) {
  return { type: actions.ATTEMPT_GET_MEASUREMENT_DATA_SUCCEED, payload: { data } };
}

export function attemptGetMeasurementDataFailed(data) {
  return { type: actions.ATTEMPT_GET_MEASUREMENT_DATA_FAILED, payload: { data } };
}
